import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import AllInOneHome from "./pages/AllInOneHome";
import LeadGenHome from "./pages/LeadGenHome";
import EngagementHome from "./pages/engagement/EngagementHome";
import EngagementSaasHome from "./pages/engagement-saas/EngagementSaasHome";
import ClientHome from "./pages/ClientHome";
import ScrollToTop from "./components/ScrollToTop";
import MetaTagsUpdater from "./components/MetaTagsUpdater";
import JsonLd from "./components/JsonLd";
import { EventPage } from "./components/EventPage";
// import PublicPreview from "./pages/PublicPreview";
// import PublicPreviewV2 from "./components/PublicPreviewV2";
import FreeQuizMagnet from "./components/Magnets/FreeQuizMagnet";
import EbookMagnet from "./components/Magnets/EbookMagnet";
import FunnelTemplateMagnet from "./components/Magnets/FunnelTemplateMagnet";
import WebinarMagnet from "./components/Magnets/WebinarMagnet";
import GiftsPage from "./pages/GiftsPage";
import PublicPreviewHT from "./pages/PublicPreviewHT/index";
import BlogDetails from "./pages/BlogDetails";
import BlogPage from "./pages/BlogPage";
import AboutPage from "./pages/AboutPage";
import EnterpriseHome from "./pages/EnterpriseHome";
import SaasHome from "./pages/SaasHome";
import OdooPartnershipHome from "./pages/OdooPartnershipHome";
import OdooOnePagerPage from "./pages/OdooOnePagerPage";
import OdooSlideDeckPage from "./pages/OdooSlideDeckPage";
import SmallBusinessUseCase from "./pages/SmallBusinessUseCase";
import SoloServiceProUseCase from "./pages/SoloServiceProUseCase";
import ReferralAgent from "./pages/features/ReferralAgent";
import CustomerHappinessAgent from "./pages/features/CustomerHappinessAgent";
import VisibilityEngagementAgent from "./pages/features/VisibilityEngagementAgent";
import PredictableGrowthAgent from "./pages/features/PredictableGrowthAgent";
import CustomerInsightAgent from "./pages/features/CustomerInsightAgent";
import AssetAIAgent from "./pages/features/AssetAIAgent";
import FliersHome from "./pages/FliersHome";
import MedSpaHome from "./pages/MedSpaHome";
import PricingPage from "./pages/PricingPage";
import BookDemoPage from "./pages/book-demo/BookDemoPage";
import RequestsPage from "./pages/RequestsPage";
import ShopifyPage from "./pages/ShopifyPage";
import NigeriaHome from "./pages/NigeriaHome";
import KolanutThesisPage from "./pages/kolanut-thesis/KolanutThesisPage";
import HealingPage from "./pages/healing/HealingPage";
import NotFoundPage from "./pages/NotFoundPage";
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <Router>
      {/* Add ScrollToTop and MetaTagsUpdater just inside the Router */}
      <ScrollToTop />
      <MetaTagsUpdater />
      <JsonLd />
      <Routes>
        <Route path="/" element={<EngagementSaasHome />} />
        <Route path="/solutions-d2c" element={<EngagementHome />} />
        <Route path="/solutions-saas" element={<Navigate to="/" replace />} />
        <Route path="/solutions/paid-ads" element={<LeadGenHome />} />
        <Route path="/book-demo" element={<BookDemoPage />} />
        <Route path="/ng" element={<NigeriaHome />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/agencies" element={<EnterpriseHome />} />
        <Route path="/saas" element={<SaasHome />} />
        <Route path="/odoo" element={<OdooPartnershipHome />} />
        <Route path="/odoo/one-pager" element={<OdooOnePagerPage />} />
        <Route path="/odoo/slide-deck" element={<OdooSlideDeckPage />} />
        <Route path="/use-case/small-business" element={<SmallBusinessUseCase />} />
        <Route path="/use-case/solo-pro" element={<SoloServiceProUseCase />} />
        <Route path="/features/referral" element={<ReferralAgent />} />
        <Route path="/features/customer-happiness" element={<CustomerHappinessAgent />} />
        <Route path="/features/visibility-engagement" element={<VisibilityEngagementAgent />} />
        <Route path="/features/predictable-growth" element={<PredictableGrowthAgent />} />
        <Route path="/features/customer-insight" element={<CustomerInsightAgent />} />
        <Route path="/features/auto-branded-assets" element={<AssetAIAgent />} />
        <Route path="/all-in-one-coaching" element={<AllInOneHome />} />
        <Route path="/client" element={<ClientHome />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/event/*" element={<EventPage />} />
        <Route path="/ht_phyt" element={<PublicPreviewHT />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        {/* <Route path="/ht_phyt" element={<PublicPreviewV2 />} /> */}
        <Route path="/gifts" element={<GiftsPage />} />
        <Route path="/gifts/free-quiz" element={<FreeQuizMagnet />} />
        <Route path="/gifts/ebook" element={<EbookMagnet />} />
        <Route path="/gifts/funnel-template" element={<FunnelTemplateMagnet />} />
        <Route path="/gifts/webinar" element={<WebinarMagnet />} />
        <Route path="/fliers-home" element={<FliersHome />} />
        <Route path="/medspa" element={<MedSpaHome />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/requests" element={<RequestsPage />} />
        <Route path="/shopify" element={<ShopifyPage />} />
        <Route path="/kolanut-thesis" element={<KolanutThesisPage />} />
        <Route path="/healing" element={<HealingPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
